/* Hubsite theme interactions (ported from approved demo, original code) */
(()=>{ /* hero */
  const slides=[...document.querySelectorAll(".hero__slide")]; if(!slides.length)return;
  const dots=document.getElementById("heroDots"); if(!dots)return;
  dots.innerHTML=slides.map((_,i)=>`<button class="${i===0?"sel":""}" aria-label="slide ${i+1}"></button>`).join("");
  const dbs=[...dots.children]; let i=0,t;
  const go=n=>{slides[i].classList.remove("active");dbs[i].classList.remove("sel");
    i=(n+slides.length)%slides.length;slides[i].classList.add("active");dbs[i].classList.add("sel");};
  dbs.forEach((d,n)=>d.addEventListener("click",()=>{go(n);reset();}));
  const reset=()=>{clearInterval(t);t=setInterval(()=>go(i+1),7000);};reset();
})();
(()=>{ /* flash countdown */
  document.querySelectorAll("[data-countdown]").forEach(el=>{
    const end=new Date(el.dataset.countdown).getTime(); if(!end)return;
    const tick=()=>{let s=Math.max(0,Math.floor((end-Date.now())/1000));
      const d=Math.floor(s/86400);s%=86400;const h=Math.floor(s/3600);s%=3600;const m=Math.floor(s/60);s%=60;
      el.innerHTML=[[d,"Days"],[h,"Hours"],[m,"Mins"],[s,"Secs"]].map(([v,l])=>`<div><b>${String(v).padStart(2,"0")}</b><span>${l}</span></div>`).join("");};
    tick();setInterval(tick,1000);});
})();
(()=>{ /* faq accordion */
  document.querySelectorAll(".qa__head").forEach(h=>h.addEventListener("click",()=>{
    const it=h.parentElement;
    it.parentElement.querySelectorAll(".qa").forEach(x=>x!==it&&x.classList.remove("open"));
    it.classList.toggle("open");}));
})();
(()=>{ /* featured product pills + qty */
  document.querySelectorAll(".hub-fs").forEach(root=>{
    const price=root.querySelector(".fs-price"),idInput=root.querySelector(".fs-variant-id");
    root.querySelectorAll(".pill[data-vid]").forEach(p=>p.addEventListener("click",()=>{
      root.querySelectorAll(".pill").forEach(x=>x.classList.remove("sel"));p.classList.add("sel");
      if(idInput)idInput.value=p.dataset.vid; if(price)price.textContent=p.dataset.vprice;}));
    const wrap=root.querySelector(".fsingle__thumbs"),main=root.querySelector(".fs-main-img");
    wrap&&wrap.querySelectorAll("img").forEach(tt=>tt.addEventListener("click",()=>{
      main.src=tt.dataset.full||tt.src;wrap.querySelectorAll("img").forEach(x=>x.classList.remove("sel"));tt.classList.add("sel");}));
  });
  document.querySelectorAll(".qty button").forEach(b=>{if(b.dataset.bound)return;b.dataset.bound=1;
    b.addEventListener("click",e=>{e.preventDefault();const s=b.parentElement.querySelector("input")||b.parentElement.querySelector("span");
      const v=Math.max(1,(+ (s.value||s.textContent))+(b.textContent==="−"?-1:1));
      if(s.value!==undefined&&s.tagName==="INPUT")s.value=v;else s.textContent=v;});});
})();
(()=>{ /* testimonial switch */
  document.querySelectorAll(".testi").forEach(root=>{
    const data=JSON.parse(root.querySelector(".testi-data")?.textContent||"[]"); if(!data.length)return;
    let i=0;const txt=root.querySelector(".testi-text"),who=root.querySelector(".testi-who"),ttl=root.querySelector(".testi-title");
    const dots=[...root.querySelectorAll(".testi__nav .dot")],btns=[...root.querySelectorAll(".testi__nav button")];
    const show=n=>{i=(n+data.length)%data.length;txt.textContent=data[i].q;who.textContent=data[i].a;if(ttl)ttl.textContent=data[i].t;
      dots.forEach((d,k)=>d.classList.toggle("sel",k===i));};
    btns[0]&&btns[0].addEventListener("click",()=>show(i-1));btns[1]&&btns[1].addEventListener("click",()=>show(i+1));});
})();
(()=>{ /* reveal */
  const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add("in");io.unobserve(e.target);}}),{threshold:.1});
  document.querySelectorAll(".reveal").forEach(el=>io.observe(el));
})();
(()=>{ /* mobile drawer + search + mega menu（元素由 header section 渲染） */
  const dr=document.querySelector(".mdrawer"),ov=document.querySelector(".moverlay");
  const open=()=>{dr&&dr.classList.add("open");ov&&ov.classList.add("open");document.body.style.overflow="hidden";};
  const close=()=>{dr&&dr.classList.remove("open");ov&&ov.classList.remove("open");document.body.style.overflow="";};
  document.getElementById("mMenu")?.addEventListener("click",open);
  ov?.addEventListener("click",close);
  dr?.querySelector(".mdrawer__close")?.addEventListener("click",close);
  const sr=document.querySelector(".msearch");
  document.getElementById("mSearch")?.addEventListener("click",()=>sr&&sr.classList.toggle("open"));
  const pill=document.querySelector(".header__pill"),panel=document.querySelector(".megamenu");
  if(pill&&panel){
    const catbtn=pill.querySelector(".catbtn");
    const colNav=[...pill.querySelectorAll(".nav a")].find(a=>/collection/i.test(a.textContent));
    let t;const show=()=>{clearTimeout(t);panel.classList.add("open");catbtn&&catbtn.classList.add("act");};
    const hide=()=>{t=setTimeout(()=>{panel.classList.remove("open");catbtn&&catbtn.classList.remove("act");},170);};
    [catbtn,colNav,panel].filter(Boolean).forEach(el=>{el.addEventListener("mouseenter",show);el.addEventListener("mouseleave",hide);});
    catbtn&&catbtn.addEventListener("click",e=>{e.stopPropagation();
      panel.classList.contains("open")?(panel.classList.remove("open"),catbtn.classList.remove("act")):show();});
    document.addEventListener("click",e=>{if(!panel.contains(e.target)&&!catbtn.contains(e.target)){panel.classList.remove("open");catbtn&&catbtn.classList.remove("act");}});
  }
})();
